var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card h-100" }, [
    _c("div", { staticClass: "d-flex justify-content-center card-header" }, [
      _c("h5", { staticClass: "m-0 mr-1" }, [
        _vm._v(" " + _vm._s(_vm.T.schoolOfTheMonth) + " ")
      ]),
      _c(
        "a",
        {
          staticClass: "card-header-help",
          attrs: { href: _vm.NewSchoolofTheMonthFeatureURL }
        },
        [_c("font-awesome-icon", { attrs: { icon: ["fas", "info-circle"] } })],
        1
      )
    ]),
    _c(
      "div",
      {
        staticClass:
          "card-body text-center d-flex flex-column justify-content-center"
      },
      [
        _c(
          "h5",
          { staticClass: "card-title" },
          [
            _vm.schoolOfTheMonth.country_id !== null
              ? _c("omegaup-countryflag", {
                  staticClass: "mr-1",
                  attrs: { country: _vm.schoolOfTheMonth.country_id }
                })
              : _vm._e(),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "/schools/profile/" + _vm.schoolOfTheMonth.school_id + "/"
                }
              },
              [_vm._v(_vm._s(_vm.schoolOfTheMonth.name))]
            )
          ],
          1
        ),
        _vm.schoolOfTheMonth.state && _vm.schoolOfTheMonth.country
          ? _c("div", { staticClass: "card-text" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.schoolOfTheMonth.state) +
                  ", " +
                  _vm._s(_vm.schoolOfTheMonth.country) +
                  " "
              )
            ])
          : _vm._e()
      ]
    ),
    _c("div", { staticClass: "card-footer text-center" }, [
      _c("a", { attrs: { href: "/schoolofthemonth/" } }, [
        _vm._v(_vm._s(_vm.T.coderOfTheMonthFullList))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }